module.exports = __webpack_public_path__ + "static/media/institutions-2.6ff3a196.png";